import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth.service';
@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./shared.css']
})
export class VerifyComponent {
  message = 'Verifying...';
  constructor(private route: ActivatedRoute, private auth: AuthService, private router: Router) {
    const token = this.route.snapshot.queryParamMap.get('token') || '';
    this.auth.verify(token).subscribe({
      next: () => { this.message = 'Email verified successfully'; setTimeout(() => this.router.navigate(['/login']), 1200); },
      error: (err) => this.message = err?.error?.error || 'Verification failed'
    });
  }
}
